export default "__VITE_ASSET__D4RP_YHT__"